import Dialog from "material-ui/Dialog";
import Button from "components/form/button";
import PropTypes from "prop-types";
import React, { PureComponent } from "react";
import app from "lib/app";
import Loading from "components/loading/loading";
import Globalize from "globalize";

class WorkingOrderLoadingDialog extends PureComponent {
    dialogStyles = {
        position: "absolute",
        left: "50%",
        top: "50%",
        transform: "translate(-50%, -50%)",
    };

    static propTypes = {
        shouldShowWorkingOrder: PropTypes.bool.isRequired,
        canStartLoadingWorkingOrder: PropTypes.bool.isRequired,
        onToggleDialog: PropTypes.func.isRequired,
        onCartLoad: PropTypes.func.isRequired,
    };

    constructor(props) {
        super(props);
        this.state = {
            isWorkingOrderShown: false,
            displayMessage: Globalize.formatMessage("Please wait while we load your working order..."),
        };
        this.closeWorkingOrderLoadaingDialog = this.closeWorkingOrderLoadaingDialog.bind(this);
    }

    UNSAFE_componentWillMount() {
        app.on("legacy:working-order", this.handleWorkingOrder, this);
        app.on("legacy:working-order-fail", this.handleWorkingOrderError, this);
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        if (!this.props.canStartLoadingWorkingOrder && nextProps.canStartLoadingWorkingOrder) {
            this.tryToOpenWorkingOrder();
        }
    }

    tryToOpenWorkingOrder = () => {
        if (this.props.shouldShowWorkingOrder && !this.state.isWorkingOrderShown) {
            this.props.onCartLoad();
        }
    };

    handleWorkingOrder({ open }) {
        this.setState({
            isWorkingOrderShown: open,
        });

        this.closeWorkingOrderLoadaingDialog();
    }

    handleWorkingOrderError({ displayMessage }) {
        displayMessage = displayMessage || Globalize.formatMessage("There was an error opening the working order.");
        this.setState({ displayMessage });
    }

    closeWorkingOrderLoadaingDialog() {
        this.props.onToggleDialog(false);
    }

    render() {
        const showLoadingModal = this.props.shouldShowWorkingOrder && !this.state.isWorkingOrderShown;

        const actions = [
            // eslint-disable-next-line react/jsx-key
            <Button
                label={Globalize.formatMessage("Cancel")}
                primary={true}
                onClick={this.closeWorkingOrderLoadaingDialog}
            />,
        ];

        return (
            <Dialog
                contentStyle={this.dialogStyles}
                actions={this.props.canStartLoadingWorkingOrder ? [] : actions}
                modal={false}
                open={showLoadingModal}
            >
                <h1>{this.state.displayMessage}</h1>
                <Loading />
            </Dialog>
        );
    }
}

export default WorkingOrderLoadingDialog;
